<template>
  <v-app>
    <auth-core-view />
  </v-app>
</template>

<script>
  export default {
    name: 'AuthIndex',

    components: {
      AuthCoreView: () => import('./components/core/View'),
    },

    created () {
      this.$vuetify.theme.dark = true
    },

    beforeDestroy () {
      this.$vuetify.theme.dark = false
    },
  }
</script>
